/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Messages = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10 19C14.9706 19 19 14.9706 19 10C19 9.32319 19 7.71453 18.0429 5.95689C16.5621 3.01683 13.5166 1 10 1C5.02944 1 1 5.02944 1 10V17.65C1 18.3956 1.60442 19 2.35 19H6.51561H10ZM17.65 10C17.65 14.225 14.225 17.65 10 17.65H7.70872H2.35V10C2.35 5.77502 5.77502 2.35 10 2.35C13.1842 2.35 15.914 4.29544 17.0657 7.06257C17.4422 7.96701 17.65 8.95923 17.65 10ZM6.4 10.9C6.89706 10.9 7.3 10.4971 7.3 10C7.3 9.50294 6.89706 9.1 6.4 9.1C5.90294 9.1 5.5 9.50294 5.5 10C5.5 10.4971 5.90294 10.9 6.4 10.9ZM10.9 10C10.9 10.4971 10.4971 10.9 10 10.9C9.50294 10.9 9.1 10.4971 9.1 10C9.1 9.50294 9.50294 9.1 10 9.1C10.4971 9.1 10.9 9.50294 10.9 10ZM13.6772 10.8967C14.1381 10.8576 14.5 10.4711 14.5 10C14.5 9.98875 14.4998 9.97754 14.4994 9.96638C14.4817 9.4849 14.0858 9.1 13.6 9.1C13.1029 9.1 12.7 9.50294 12.7 10C12.7 10.4971 13.1029 10.9 13.6 10.9C13.626 10.9 13.6517 10.8989 13.6772 10.8967ZM14 22.9999C11.5847 22.9999 9.39167 22.0484 7.77515 20.5H9.96428C11.1358 21.2288 12.5187 21.6499 14 21.6499H21.65V13.9999C21.65 12.3055 21.0992 10.7397 20.1668 9.472V7.44458C21.9109 9.08601 23 11.4158 23 13.9999V21.6499C23 22.3954 22.3956 22.9999 21.65 22.9999H14Z"
                        fill={color}
                    />
                </svg>
        );
    };
